import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { TreeTable } from "primereact/treetable";
import { statusTemplate, actionTemplate } from "./FamiliaActionTemplate";
import { SelectButton } from 'primereact/selectbutton';

const FamiliasTreePanel = ({
    nodes,
    loading,
    tipo,
    tipoOptions,
    setTipo,
    activas,
    setActivas,
    selectedFamilia,
    setSelectedFamilia,
    selectedFamiliaData,
    onNodeSelect,
    onNodeUnselect,
    onAgregarClick,
    onSubirPrioridad,
    onBajarPrioridad,
    onToggleActivo,
    onEliminar,
    onEditar,
    onVerProductos,
    actionLoading,
}) => {
    const headerTree = (
        <div className="flex align-items-center justify-content-between flex-wrap gap-2">
            <span className="text-xl font-semibold">Familias</span>
            
            <SelectButton value={tipo} options={tipoOptions} onChange={(e) => setTipo(e.value)} className="text-sm"/>
            

            <div className="flex align-items-center gap-2">
                <Checkbox checked={!activas} onChange={(e) => setActivas(!e.checked)} />
                <span className="text-sm font-semibold">Mostrar inactivas</span>
            </div>

            <div className="flex align-items-center gap-2">
                <Button
                    icon="pi pi-plus"
                    label="Agregar"
                    onClick={onAgregarClick}
                    severity="success"
                />
            </div>
        </div>
    );

    const renderAction = (rowData) => actionTemplate(rowData, {
        onEditar,
        onEliminar,
        onToggle: onToggleActivo,
        onVerProductos,
        loading: actionLoading,
    });

    return (
        <div className="col-12 lg:col-7">
            <TreeTable
                value={nodes}
                header={headerTree}
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 25]}
                scrollable
                scrollHeight="calc(85vh - 370px)"
                loading={loading || actionLoading}
                selectionMode="single"
                selectionKeys={selectedFamilia}
                onSelectionChange={(e) => setSelectedFamilia(e.value)}
                onSelect={(e) => onNodeSelect(e.node)}
                onUnselect={() => onNodeUnselect()}
            >
                <Column field="name" header="Nombre" expander />
                <Column field="orden" header="Orden" style={{ width: "10%" }} />
                <Column body={statusTemplate} header="Estado" style={{ width: "10%" }} />
                <Column body={renderAction} header="" style={{ width: "25%" }} />
            </TreeTable>

            <div className="flex gap-2 mt-3">
                <Button
                    size="small"
                    rounded
                    icon="pi pi-arrow-up"
                    tooltip="Subir prioridad"
                    onClick={onSubirPrioridad}
                    disabled={!selectedFamiliaData}
                />
                <Button
                    size="small"
                    rounded
                    icon="pi pi-arrow-down"
                    tooltip="Bajar prioridad"
                    onClick={onBajarPrioridad}
                    disabled={!selectedFamiliaData}
                />
            </div>
        </div>
    );
};

export default FamiliasTreePanel;